export default "__VITE_ASSET__Bfu1KJ6U__"